const rulesByLang = new Map<string, Intl.PluralRules>();

export function pluralCategory(lang: string, count: number): string {
  let rules = rulesByLang.get(lang);

  if (!rules) {
    rules = new Intl.PluralRules(lang);
    rulesByLang.set(lang, rules);
  }

  return rules.select(count).toUpperCase();
}
